import { DatePicker, Form } from 'antd';
import i18n from 'i18next';
import moment from 'moment';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';
import { DATE_FORMATS, USER_PREFERENCES } from '../../../contants/common';
import useUserPreference from '../../../redux/hooks/useUserPreference';
import { isRequiredField } from '../../../utilz';

const MyDatePicker = DatePicker.generatePicker(momentGenerateConfig);

const FormDatePicker = ({
  placeholder = i18n.t('translation:default.date'),
  label,
  margin = 'mb-15',
  name = `testFiled-${Math.random()}`,
  rules = [],
  editMode = true,
  disabled,
  onChange = false,
  disabledTargetDate = false,
  disableFuture = false,
  format = false,
  singleLineMode = false,
  disableValidation = false,
  allowClear = true,
  tabIndex,
  defaultData,
  dataTestId,
}) => {
  const userDateFormat = useUserPreference(USER_PREFERENCES.DEFAULT_DATE_FORMAT);

  const defaultValue = moment(defaultData, 'MM/DD/YYYY');

  return (
    <Form.Item
      className={`${
        singleLineMode ? 'single-line-mode' : ''
      } form-input-container ${margin} ${!editMode ? 'edit-mode-off' : ''} `}
      name={name}
      {...(label
        ? {
            label: (
              <span>
                {label}
                {rules.length > 0 && isRequiredField(rules) && <span className="required">*</span>}
              </span>
            ),
          }
        : {})}
      rules={disableValidation ? [] : rules}
      colon={false}
      data-testid={dataTestId}
    >
      <MyDatePicker
        allowClear={allowClear}
        defaultValue={defaultData && defaultValue}
        format={format ? format : userDateFormat ? userDateFormat : DATE_FORMATS['MM/DD/YYYY']}
        changeOnBlur
        disabledDate={
          disabledTargetDate
            ? (current) => {
                const customDate = disabledTargetDate
                  ? moment(disabledTargetDate).format('YYYY-MM-DD')
                  : moment().format('YYYY-MM-DD');
                if (disableFuture) {
                  return current && current > moment(customDate, 'YYYY-MM-DD');
                }
                return current && current < moment(customDate, 'YYYY-MM-DD');
              }
            : ''
        }
        placeholder={editMode ? placeholder : ''}
        className="form-datepicker"
        disabled={disabled}
        {...(onChange ? { onChange } : {})}
        id={name}
        tabIndex={tabIndex}
      />
    </Form.Item>
  );
};

export default FormDatePicker;
